import canAutoplay from 'can-autoplay';
import { detect } from 'detect-browser';

import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';

const userBrowser = detect();

const prepareAutoPlay = async (): Promise<void> => {
    if (
        userBrowser &&
        (userBrowser.name === 'safari' || userBrowser.os?.toLocaleLowerCase() === 'ios') &&
        !(getTelegramWebApp() && getTelegramWebApp()?.platform === 'ios')
    ) {
        // Avoid ugly bug on safari ios where the player opens with native fullscreen controls
        return Promise.resolve();
    }
    return canAutoplay.video({ muted: false, timeout: 1500, inline: true });
};

export default prepareAutoPlay;
